import { render, staticRenderFns } from "./CAJG1040.vue?vue&type=template&id=5c3043bc"
import script from "./CAJG1040Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAJG1040Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports